import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ButtonGroup from "../../ui/ButtonGroup/ButtonGroup";
import Select from "../../ui/Select/Select";
import Table from "../../ui/Table/Table";
import { FixedHeader, PrimaryHeader } from "../../ui/Header";
import "./Buy.scss";
import classnames from "classnames";
import DateRange from "../../ui/DateRange/DateRange";

import useSort from "../../hooks/useSort";
import useSearch from "../../hooks/useSearch";

import { BuyoutStatService } from "../../utils/api";

import SlotSelect from "./SlotSelect";

import { teaserListDetail } from "../../utils/urls";
import spaceint2 from "../../utils/spaceint2";
import { buyoutStatus } from "../../constants";

import moment from "moment";

const renderSpaceint2 = ({ data, columnInfo }) => (
  <span>{spaceint2(data[columnInfo.accessor])}</span>
);
const renderSummarySpaceint2 = ({ summaryInfo, summary }) => (
  <span>{spaceint2(summary[summaryInfo.accessor])}</span>
);

const extraColumns = [
  {
    _key: "e1",
    className: "table__border-right",
    colSpan: 5
  },
  {
    _key: "e2",
    className: "table__border-right",
    colSpan: 3,
    title: "rb.mail.ru"
  },
  {
    _key: "e3",
    title: "Content"
  },
  {
    _key: "e4",
    title: ""
  }
];

const columns = [
  {
    className: "id1",
    dataClassName: "id1",
    title: "ID (mail)",
    accessor: "id",
    renderDataCell: ({ columnInfo, data }) => {
      return (
        <div>
          <span
            className={classnames("page-buy__teaser-status", {
              green: !data.is_stopped,
              gray: data.is_stopped
            })}
          />
          <span>
            <a
              href={`https://rb.mail.ru/banners/${data[columnInfo.accessor]}/`}
              target="_blank"
            >
              {data[columnInfo.accessor]}
            </a>
          </span>
        </div>
      );
    }
  },
  {
    className: "id2",
    dataClassName: "id2",
    title: "ID (cntnt)",
    accessor: "content_ids",
    renderDataCell: ({ data }) => {
      return data.content_ids.map(id => {
        return (
          <Link
            className="page-buy__teaser-url"
            to={teaserListDetail(id)}
            target="_blank"
          >
            {id}
          </Link>
        );
      });
    }
  },
  {
    className: "title",
    dataClassName: "title",
    title: "Заголовок",
    accessor: "title"
  },
  {
    className: "tgb",
    dataClassName: "tgb",
    title: "ТГБ",
    accessor: "slot_name"
  },
  {
    className: "table__border-right arpu",
    dataClassName: "table__border-right arpu",
    summaryClassName: "table__border-right arpu",
    title: "ARPU (M)",
    accessor: "arpu_model"
  },
  {
    className: "shows",
    dataClassName: "shows",
    title: "Показы",
    accessor: "shows",
    renderDataCell: renderSpaceint2
  },
  {
    className: "ctr",
    dataClassName: "ctr",
    title: "CTR",
    accessor: "ctr"
  },
  {
    className: "table__border-right clicks1",
    dataClassName: "table__border-right clicks1",
    summaryClassName: "table__border-right clicks1",
    title: "Переходы",
    accessor: "clicks",
    renderDataCell: renderSpaceint2
  },
  {
    className: "clicks2",
    dataClassName: "clicks2",
    title: "Переходы",
    accessor: "content_clicks",
    renderDataCell: renderSpaceint2
  },
  {
    className: "r_kpi",
    dataClassName: "r_kpi",
    title: "KPI",
    accessor: "r_kpi"
  }
];

const summaryColumns = [
  {
    title: "Итого",
    colSpan: 4
  },
  {
    accessor: "arpu_model",
    className: "table__border-right",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "shows",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "ctr"
  },
  {
    accessor: "clicks",
    className: "table__border-right",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "content_clicks",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "r_kpi",
    className: "r_kpi"
  }
];

const Buy = ({ location, history }) => {
  const [state, setState] = useState({ stat: [], summary: {} });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useSearch(
    {
      date_from: moment().format("YYYY-MM-DD"),
      date_to: moment().format("YYYY-MM-DD"),
      slot: "",
      status: "all"
    },
    location,
    history
  );
  const { sortBy, sortOrder, onSortChange } = useSort("id", "asc");

  useEffect(() => {
    setLoading(true);
    BuyoutStatService(search)
      .then(data => {
        setState(data);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [search]);

  const onDateChange = ({ startDate, endDate }) => {
    setSearch({
      date_from: moment(startDate).format("YYYY-MM-DD"),
      date_to: moment(endDate).format("YYYY-MM-DD")
    });
  };

  const onSlotChange = item => {
    setSearch({ slot: item.value });
  };

  const onStatusChange = item => {
    setSearch({ status: item.value });
  };

  return (
    <div className="page-buy">
      <FixedHeader>
        <PrimaryHeader className="x">
          <span className="header__title">Выкуп</span>
          <ButtonGroup
            items={[
              { title: "Общая", code: "common" },
              { title: "По анонсам", code: "teasers" }
            ]}
            theme="dark"
            selected="teasers"
          />
          <Select
            className="page-buy__status"
            theme="dark"
            options={buyoutStatus}
            value={search.status}
            onSelect={onStatusChange}
          />
          <SlotSelect
            placeholder="Выбор ТГБ"
            theme="dark"
            value={parseInt(search.slot)}
            onSelect={onSlotChange}
          />
        </PrimaryHeader>
      </FixedHeader>

      <div className="content-body content-body__with-fixed">
        <div className="page-buy__date-range">
          <DateRange
            className="left"
            onChange={onDateChange}
            startDate={moment(search.date_from)}
            endDate={moment(search.date_to)}
          />
        </div>
        <Table
          columns={columns}
          extraColumns={extraColumns}
          data={state.stat}
          summary={state.summary}
          summaryColumns={summaryColumns}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onSortChange={onSortChange}
          className="buy"
          getTrProps={({ data }) => {
            if (data.is_stopped) {
              return { className: "inactive" };
            }
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Buy;
